import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  FormHelperText,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  ToggleButton,
  ToggleButtonGroup
} from "@material-ui/lab";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import { useLoading } from "../../../../util/LoadingProvider";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import dayjs from "dayjs";

const schema = yup.object().shape({
  categoryId: yup.number().required("Category is required."),
});

const defaultFormValues = {
  categoryId: "",
  filmId: "",
  filmShowCode: "",
  localizations: {
    en: {
      description: null
    },
    tc: {
      description: null
    }
  },
  displayDate: null,
  status: true
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  textInput: {
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "362px",
    },
  },
  buttonGroup: {
    marginTop: "40px",
    textAlign: "left",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  input: {
    width: "100%",
  },
  errorMsg: {
    color: "red",
    marginLeft: "6px",
  }
}));

export default function ProgrammeEditPage({
  disabled,
  ...props
}) {
  const { match } = props;
  const id = match.params.id;
  const history = useHistory();
  const [defaultValues, setDefaultValues] = useState(defaultFormValues);
  const { setLoading } = useLoading();
  const [categoryList, setCategoryList] = useState([]);
  const [filmList, setFilmList] = useState([]);
  const [filmId, setFilmId] = useState("");
  const [film, setFilm] = useState("");
  const [filmIdErr, setFilmIdErr] = useState(false);


  const [codeList, setCodeList] = useState([]);
  const [codeIds, setCodeIds] = useState([]);
  const [codes, setCodes] = useState([]);
  const [programmeTypeList, setProgrammeTypeList] = useState([]);
  const [programmeType, setProgrammeType] = useState("");
  const [programmeTypeId, setProgrammeTypeId] = useState("");
  const [filmCodeErr, setFilmCodeErr] = useState(false);
  const classes = useStyles();

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });




  const getFilmList = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmListing({
        page: 0,
        pageSize: 999999,
      });
      console.log('getFilmList: ', result);
      var list = result.data.content.map((film) => (
        {
          id: film.id,
          title: film.localizations.en.title
        }
      ));

      setFilmList(list);

    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [setLoading])


  const getProgrammeCategoryList = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProgrammeCategories(
        null,
        0,
        0,
        9999999,
        ''
      );
      console.log('getProgrammeCategoryList: ', result);
      setCategoryList(result.data.content.map((category) => (
        {
          id: category.id,
          name: category.localizations.en.name
        }
      )));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [setLoading])

  const onSubmit = (value) => {
    setFilmCodeErr(false);
    setFilmIdErr(false);

    const errors = {
      filmId: filmId === "",
      filmCode: !codes || codes.length === 0
    };

    if (errors.filmId) setFilmIdErr(true);
    if (errors.filmCode) setFilmCodeErr(true);

    if (!errors.filmId && !errors.filmCode) {
      const submissionValue = {
        ...value,
        programmeTypeId,
        filmShowCodes: codeIds,
        filmId
      };

      id !== "new" ? updateProgramme(submissionValue) : createProgramme(submissionValue);
    }
  };

  const getProgramme = React.useCallback(async () => {
    setLoading(true);
    try {
      const result = await apiHelper.hkiff.getHkiffProgrammeById(id);
      console.log(result);
      setDefaultValues(result.data);
      setFilmId(result.data.filmId);
      setCodeIds(result.data.filmShowCodes);
      setProgrammeTypeId(result.data.programmeTypeMapping.programmeType.id);

      reset(result.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, [id, setLoading]);

  const updateProgramme = async (value) => {
    try {
      value.filmId = filmId;
      const result = await apiHelper.hkiff.updateHkiffProgrammeById(id, value);
      console.log(result);
      if (result.data.id !== null || result.data.id !== undefined) {
        toast.dark("Your changes are saved.");
        getProgramme();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const createProgramme = async (value) => {
    try {
      const result = await apiHelper.hkiff.createHkiffProgramme(value);
      console.log(result);
      if (result.data.id !== null || result.data.id !== undefined) {
        history.push("/hkiff/programme/programme");
        toast.dark("The Programme is created.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCodingList = async (value) => {
    try {

      const result = await apiHelper.hkiff.getProgrammeScreeningCodeById(filmId);
      console.log(result);
      const uniqueCodeList = result.data;
      var codeList = uniqueCodeList.map(function (item) {
        return {
          id: item, title: item
        }
      })
      setCodeList(codeList);

    } catch (err) {
      console.log(err);
    }
  };

  const getProgrammeTypeList = async (value) => {
    try {

      const result = await apiHelper.hkiff.getProgrammeType();
      console.log(result);

      var programmeTypeList = result.data.map(function (x) {
        return {
          id: x.id, name: x.localizations.en.name
        }
      })
      console.log(programmeTypeList);
      setProgrammeTypeList(programmeTypeList);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProgrammeCategoryList();
    getFilmList();
    getProgrammeTypeList();
    if (id !== "new") getProgramme();
  }, [getProgramme, id]);

  useEffect(() => {
    setFilm(filmList.filter((f) => (f.id === filmId))[0]);
    if (filmId != "") { getCodingList(); }
  }, [filmList, filmId]);

  useEffect(() => {
    setCodes(codeList.filter((f) => codeIds.includes(f.id)));
  }, [codeList, codeIds]);

  useEffect(() => {
    setProgrammeType(programmeTypeList.filter((f) => (f.id === programmeTypeId))[0]);
  }, [programmeTypeList, programmeTypeId]);


  return (
    <div className={classes.content}>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Film &gt; {id === "new" ? "Add" : "Edit"} Programme
                </Typography>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled}
          className="fieldset">
          <Grid container xs={12} direction="row"
            spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" >{id === "new" ? "Add" : "Edit"} Programme</Typography>
            </Grid>
          </Grid>


          <Grid container xs={12} direction="row"
            style={{ marginTop: '26px' }}
            spacing={3}>
            <Grid item xs={12}>


              <FormControl fullWidth
                variant="outlined">
                <InputLabel
                  id="category-selection">
                  Category
                            </InputLabel>
                <Controller
                  name="categoryId"
                  control={control}
                  render={({
                    field,
                    fieldState: { error }
                  }) => (
                    <Select
                      labelId="category-selection-label"
                      id="category-selection"
                      label="Category"
                      value={-1}
                      className={classes.select}
                      {...field}
                      error={!!error}
                    >
                      {/* {
                      shouldCategoryIncludeMain &&
                      <MenuItem
                        value={-1}>
                        <em>Main
                                                    Category</em>
                      </MenuItem>
                    } */}
                      {
                        categoryList.map((category, i) => (
                          <MenuItem
                            key={i}
                            value={category.id}>
                            <em>{category.name}</em>
                          </MenuItem>
                        ))
                      }
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>

            <Grid container item
              xs={12}>

              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  name="programmeTypeMapping"
                  options={programmeTypeList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label="Action Type" variant="outlined" />}
                  value={programmeType}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setProgrammeTypeId(newValue.id);
                      setProgrammeType(newValue);
                    }
                  }}
                />
              </Grid>

            </Grid>
          </Grid>

          <Grid container xs={12} direction="row"
            spacing={3}
            xs={12}>

            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginTop: "25px", paddingLeft: "5px" }}>Film</Typography>

              <Autocomplete
                fullWidth
                name="filmId"
                options={filmList}
                getOptionLabel={(option) => option.title}
                renderInput={(params) => <TextField {...params} label="Film" variant="outlined" />}
                value={film}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFilmId(newValue.id);
                    setFilm(newValue);
                    setCodeIds([]);
                  }
                }}
              />

              {filmIdErr && (
                <FormHelperText className={classes.errorMsg}>
                  Film must not be empty.
                </FormHelperText>

              )}
            </Grid>

          </Grid>


          <Grid container xs={12} direction="row"
            spacing={3}
            xs={12}>

            <Grid item xs={12}>
              <Autocomplete
                multiple
                fullWidth
                name="filmShowCode"
                options={codeList}
                getOptionLabel={(option) => option.title}
                renderInput={(params) => <TextField {...params} label="Film Code" variant="outlined" />}
                value={codes || []}
                onChange={(event, newValues) => {
                  setCodeIds(newValues.map(v => v.id));
                  setCodes(newValues);
                }}
              />

              {filmCodeErr && (
                <FormHelperText className={classes.errorMsg}>
                  Please select at least one film code.
                </FormHelperText>

              )}

            </Grid>



          </Grid>


          <Grid container xs={12} direction="row"
            style={{ marginTop: '26px' }}
            spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="localizations.en.description"
                defaultValue=""
                render={({ field }) => {
                  return (
                    <TextField
                      id="outlined-basic"
                      className={classes.root}
                      label="Description (English)"
                      variant="outlined"
                      multiline
                      rows={4}
                      {...field}
                      fullWidth
                    />
                  );
                }}
              />
            </Grid>
          </Grid>


          <Grid container xs={12} direction="row"
            style={{ marginTop: '26px' }}
            spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="localizations.tc.description"
                defaultValue=""
                render={({ field }) => {
                  return (
                    <TextField
                      id="outlined-basic"
                      className={classes.root}
                      label="Description (Traditional Chinese)"
                      variant="outlined"
                      multiline
                      rows={4}
                      {...field}
                      fullWidth
                    />
                  );
                }}
              />
            </Grid>
          </Grid>



          {/* <Grid container xs={12} direction="row"
            style={{ marginTop: '26px' }}
            spacing={3}>
            <Grid item xs={12}>
              <Controller
                name="filmShowCode"
                control={control}
                render={({
                  field,
                  fieldState: { error }
                }) => (
                  <TextField
                    label="Code"
                    variant="outlined"
                    margin="dense"
                    className={classes.textInput}
                    fullWidth
                    {...field}
                    error={!!error}
                    helperText={error ? error.message : ""}
                  />
                )}
              />
            </Grid>
          </Grid> */}

          <Grid container xs={12} direction="row"
            style={{ marginTop: '26px' }}
            spacing={3}>
            <Grid item xs={12}>
              <Controller
                name={`displayDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <KeyboardDateTimePicker
                    fullWidth
                    variant="dialog"
                    format="d MMM yyyy, hh:mma"
                    margin="dense"
                    id="date-picker-inline"
                    label="Display Date"
                    {...field}
                    disabled={disabled}
                    onChange={(value) => {
                      setValue(
                        "displayDate",
                        dayjs(value).format("YYYY-MM-DDTHH:mm:00")
                      );
                    }}
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        fontWeight: 700,
                        color: "#333333",
                      },
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date and time",
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>



          <Grid
            container
            item
            xs={12}
            spacing={3}
            style={{
              marginTop: "20px",
              marginLeft: 0
            }}
          >
            <Grid item xs={3}
              style={{ paddingLeft: "4px" }}>
              <Controller
                control={control}
                name="status"
                render={({
                  field: {
                    value,
                    onChange,
                    ...rest
                  },
                  fieldState: { error },
                }) => (
                  <ToggleButtonGroup
                    {...rest}
                    value={value}
                    onChange={(event, newFormats) => {
                      onChange(newFormats);
                    }}
                    exclusive
                    aria-label="Status"
                    className={classes.input}
                  >
                    <ToggleButton
                      value={true}
                      aria-label="Active"
                      style={{ width: "50%" }}
                      disabled={disabled}
                    >
                      Active
                                        </ToggleButton>
                    <ToggleButton
                      value={false}
                      aria-label="Inactive"
                      style={{ width: "50%" }}
                      disabled={disabled}
                    >
                      Inactive
                                        </ToggleButton>
                  </ToggleButtonGroup>
                )}
              />
            </Grid>
          </Grid>

          {disabled || (
            <div
              className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Save Changes
                            </Button>
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}
